import { Injectable } from '@angular/core';
import { SignedToken } from '@shared/modules/auth/models/auth.models';

type Tokens = Pick<SignedToken, 'accessToken' | 'refreshToken'>;

@Injectable({ providedIn: 'root' })
export class AuthStorage {
  readonly accessTokenKey = 'accessToken';
  readonly refreshTokenKey = 'refreshToken';

  setTokens({ accessToken, refreshToken }: Tokens): void {
    localStorage.setItem(this.accessTokenKey, accessToken);
    localStorage.setItem(this.refreshTokenKey, refreshToken);
  }

  getTokens(): Tokens {
    return {
      accessToken: localStorage.getItem(this.accessTokenKey) || '',
      refreshToken: localStorage.getItem(this.refreshTokenKey) || '',
    };
  }
}
